import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
})
export class ColorPickerComponent implements OnInit {
  color = {
    red: 0,
    green: 0,
    blue: 0
  };
  @Input() initial: string;
  @Output() valueChanged = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    const hexToRgb = (hex: string) => {
      if (hex.length === 4) {
        const tmp = hex.split('');
        const t = [tmp[0], tmp[1], tmp[1], tmp[2], tmp[2], tmp[3], tmp[3]];
        hex = t.join('');
      }
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : {
        r: 0,
        g: 0,
        b: 0
      };
    };
    if (this.initial) {
      const els = hexToRgb(this.initial);
      this.color.red = els.r;
      this.color.green = els.g;
      this.color.blue = els.b;
    }
  }

  emitValue() {
    this.valueChanged.emit('#' + this.colorHex);
  }
  get colorHex() {
    const componentToHex = (c) => {
      const hex = c.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };
    return `${componentToHex(this.color.red)}${componentToHex(this.color.green)}${componentToHex(this.color.blue)}`;
  }
  get proofColor() {
    return `rgb(${this.color.red}, ${this.color.green}, ${this.color.blue})`;
  }
  update(type: string, ev) {
    switch (type) {
      case 'RED':
        this.color.red = ev.target.value;
        this.emitValue();
        break;
      case 'BLUE':
        this.color.blue = ev.target.value;
        this.emitValue();
        break;
      case 'GREEN':
        this.color.green = ev.target.value;
        this.emitValue();
    }

  }
}
